import React from 'react';

import RankingDetail from './RankingDetail';

const RankingShow = (props: any) => <RankingDetail {...props} view="show" />;
export default RankingShow;
